export default {
  rate_plans: []
}
